module.exports = __webpack_public_path__ + "static/product-pa50-red-dc093e588e0e2fe44de1d7cc0cf43334.png";